import { render } from "./recreate-invoice.vue?vue&type=template&id=40717c8e&scoped=true"
import script from "./recreate-invoice.vue?vue&type=script&lang=js"
export * from "./recreate-invoice.vue?vue&type=script&lang=js"

import "./recreate-invoice.vue?vue&type=style&index=0&id=40717c8e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40717c8e"]])

export default __exports__